import React from 'react';

import FeedbackForm from './FeedbackForm';

function Feedback() {
  return (
    <div>
      <header className="portal-header">
        <h1>Feedback</h1>
      </header>
      <FeedbackForm />
    </div>
  );
}

export default Feedback;
